module.exports = __webpack_public_path__ + "media/orderTips.3410a460.mp3";